import { render, staticRenderFns } from "./EditContractorRegion.vue?vue&type=template&id=57e31170"
import script from "./EditContractorRegion.vue?vue&type=script&lang=js"
export * from "./EditContractorRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports